function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { node, bool, string } from 'prop-types';
import cn from 'clsx';

/**
 * ListItem component.
 */
const ListItem = /*#__PURE__*/forwardRef(({
  children,
  className,
  separator,
  separatorTop,
  separatorBottom,
  role,
  gtmLabel,
  ...restProps
}, ref) => /*#__PURE__*/React.createElement("li", _extends({}, restProps, {
  className: cn(className, 'list-item', separator && 'list-item--separator', separatorTop && 'list-item--separator-top', separatorBottom && 'list-item--separator-bottom'),
  "data-gtm-class": gtmLabel,
  role: role,
  ref: ref
}), children));
ListItem.displayName = 'ListItem';
ListItem.defaultProps = {
  children: [],
  separator: false,
  separatorTop: false,
  separatorBottom: false,
  className: null,
  role: null,
  gtmLabel: null
};
ListItem.propTypes = {
  /** The children to be rendered within the list item. */
  children: node,
  /** Additional classes to be added to the root of the component. */
  className: string,
  /** Use the list item as a presentational separator. */
  separator: bool,
  /** Use the list item as a presentational top separator. */
  separatorTop: bool,
  /** Use the list item as a presentational bottom separator. */
  separatorBottom: bool,
  /** An ARIA role. */
  role: string,
  /** A label to be used for GTM tracking. */
  gtmLabel: string
};
export default ListItem;